import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';

import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getRegionBasicData } from '../../redux/methods/regions';
import useFetch from '../../hooks/useFetch';

import SettingsTabulator from '../../components/layouts/SettingsTabulator';
import RegionsEditName from '../../features/regions/editTabs/RegionsEditName';
import RegionsEditCountries from '../../features/regions/editTabs/RegionsEditCountries';

const propTypes = {
    location: PropTypes.object,
    getRegionBasicData: PropTypes.func,
    forceRefetch: PropTypes.bool,
};

const RegionsEdit = ({ location, getRegionBasicData, forceRefetch }) => {
    const intl = useIntl();
    const translations = intl.messages.regions.edit;
    /**
     * Deconstruct query params
     */
    const query = new URLSearchParams(location.search);
    const chosenRegionId = query.get('regionID');

    const [ data ] = useFetch(getRegionBasicData, chosenRegionId, [], forceRefetch);

    const refreshTabComponent = tabulatorId => {
        switch(tabulatorId){
            case 'regionsEditTab-name':
                return <RegionsEditName data={data}/>;
            case 'regionsEditTab-countries':
                return <RegionsEditCountries id={chosenRegionId} name={data.name}/>;
            default:
                return null;
        }
    };

    return chosenRegionId ? (
        data ? (
            <SettingsTabulator
                title={{
                    label: data.name || translations.fallbackName,
                    iconClassName: 'fa fa-edit text-primary ml-3',
                    isFilled: data.name ? false : true,
                }}
                tabulatorHeader={{
                    label: translations.tabSelectorTitle,
                    iconClassName: 'fa fa-align-justify'
                }}
                refreshTabComponent={refreshTabComponent}
                tabs={[
                    {
                        id: 'regionsEditTab-name',
                        header:  {
                            label: translations.tabs.name.title,
                            iconClassName: 'fa fa-tasks'
                        }
                    },
                    {
                        id: 'regionsEditTab-countries',
                        header:  {
                            label: translations.tabs.countries.title,
                            iconClassName: 'fa fa-flag'
                        }
                    },
                ]}
            />
        ) : null
    ) : (
        <Redirect to='/regions'/>
    );
};

RegionsEdit.propTypes = propTypes;

const mapStateToProps = (state) => ({
    forceRefetch: state.refetchers.regions,
});

const mapDispatch = {
    getRegionBasicData,
};

export default withRouter(connect(mapStateToProps, mapDispatch)(RegionsEdit));